import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Fire hydrant, ~0.75 m: red body on a base flange, domed cap with a top nut,
// two side nozzle stubs and one front nozzle toward +Z.
const RED = "#b0402e";
const RED_DARK = "#8e3324";

export const fireHydrant = defineModel({
  id: "fire-hydrant",
  batchId: "modern",
  name: "Fire hydrant",
  tags: ["modern", "outdoor", "street", "hydrant", "utility"],
  summary: "A red fire hydrant with side and front nozzles.",
  description:
    "A street fire hydrant of the Modern Living kit: a hydrant-red body on a " +
    "base flange, a domed cap with a top nut, two side nozzle stubs and one " +
    "front nozzle facing +Z. About 0.75 m high.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Base flange.
      {
        geometry: new THREE.CylinderGeometry(0.13, 0.15, 0.07, 10),
        color: RED_DARK,
        position: [0, 0.035, 0],
      },
      // Body.
      {
        geometry: new THREE.CylinderGeometry(0.105, 0.115, 0.5, 10),
        color: RED,
        position: [0, 0.32, 0],
      },
      // Domed cap + top nut.
      {
        geometry: new THREE.SphereGeometry(0.115, 10, 6),
        color: RED,
        position: [0, 0.57, 0],
        scale: [1, 0.75, 1],
      },
      {
        geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.06, 6),
        color: RED_DARK,
        position: [0, 0.66, 0],
      },
      // Side nozzle stubs.
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.12, 8),
        color: RED_DARK,
        position: [0.15, 0.42, 0],
        rotation: [0, 0, Math.PI / 2],
      },
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.045, 0.12, 8),
        color: RED_DARK,
        position: [-0.15, 0.42, 0],
        rotation: [0, 0, Math.PI / 2],
      },
      // Front nozzle toward +Z.
      {
        geometry: new THREE.CylinderGeometry(0.055, 0.055, 0.12, 8),
        color: RED_DARK,
        position: [0, 0.38, 0.15],
        rotation: [Math.PI / 2, 0, 0],
      },
    ];
  },
  animations: [],
});
